export const GOOGLE_API_KEY = 'AIzaSyD_gSD5jeHthWPnaLQyxa1o4N8Hfm-XRf4';
export const BAM_API_SEND_MESSAGE = 'http://localhost:8080/message';

export const HOME_PAGE = "";
//export const HOME_PAGE = "http://localhost:3000";